import MultipleSelectWithCorrectAnswersForm from './MultipleSelectWithCorrectAnswersForm';

export default MultipleSelectWithCorrectAnswersForm;
